export default __webpack_public_path__ + "static/media/iconnect.2d509e60.png";